
export const rutaArrel = '/';
export const rutaObservacions = '/observacions';
export const rutaIntroduirObservacions = rutaObservacions + '/introduccio';
export const rutaExportarObservacions = rutaObservacions + '/exportacio';

export const rutaAvisos = '/avisos';
export const rutaIntroduirAvisos = rutaAvisos + '/introduccio';
export const rutaEstacions = '/estacions';
export const rutaIntroduccioEstacions = rutaEstacions + '/introduccio';
export const rutaEdicioEstacions = rutaEstacions + '/edicio';
export const rutaDetallEstacions = rutaEstacions + '/detall';
export const rutaUsuaris = '/usuaris';
export const rutaIntroduccioUsuaris = rutaUsuaris + '/introduccio';
export const rutaEdicioUsuaris = rutaUsuaris + '/edicio';
export const rutaDetallUsuaris = rutaUsuaris + '/detall';
export const rutaContacte = '/contacte';
export const rutaPerfil = '/perfil';
export const rutaLogin = '/login';



// WEBPACK FOOTER //
// ./src/routes/routeConstants.js